import { lastValueFrom } from "rxjs";
import { createEffect, Show } from "solid-js";

import { App } from "./App";
import { InputField } from "./InputField";
import { Api, ApiContext } from "../util/api";
import { toString } from "../util/converters";
import { panic } from "../util/panic";

export function Login() {
    const api = new Api();

    let dialogRef!: HTMLDialogElement;
    let passwordRef!: HTMLInputElement;

    createEffect(() => {
        if (!api.logged()) {
            dialogRef.showModal();
            return;
        }
        dialogRef.close();
    });


    const back = (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        window.history.back();
    };

    const login = async (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        const pass = toString(passwordRef.value);
        try {
            if (await lastValueFrom(api.postLogin(pass))) {
                passwordRef.value = "";
                api.checkIfLogged();
            }
        } catch (err: any) {
            panic(err);
        }
    };

    return <ApiContext.Provider value={api}>
        <Show when={api.logged()}>            
            <App/>
        </Show>
        <dialog ref={dialogRef} id="login-dialog">
            <h2>Connexion</h2>
            <form onSubmit={login} autocomplete="off">
                <InputField
                    ref={passwordRef}
                    type="password"
                    id="admin-pass"
                    label="Mot de passe"
                    value=""
                    required
                    />
                <div class="actions">
                    <input type="submit" value="Valider" class="accent"/>
                    <button onClick={back}>Page précédente</button>
                </div>
            </form>
        </dialog>
    </ApiContext.Provider>;
}